import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAsButton = _resolveComponent("IconAsButton")

  return (_openBlock(), _createBlock(_component_IconAsButton, {
    icon: $props.icon,
    title: $props.title,
    onClick: $options.pickFile
  }, null, 8 /* PROPS */, ["icon", "title", "onClick"]))
}